/**
 * **STUB M2** — le mini-jeu qui n'en est pas un : un curseur 0-100 réglé à la main.
 *
 * C'est le mode « scores saisis à la main » du REPL M1 (`scripts/play.ts`), porté à l'écran :
 * il permet de jouer la boucle complète — produire, publier, encaisser, dormir — **avant**
 * que les 5 vrais mini-jeux existent. Il est affiché comme tel, sans faire semblant.
 *
 * Il disparaît étape par étape à mesure que les vrais jeux arrivent (Montage d'abord — c'est
 * le signature, PLAN §9 M2 ; puis Écriture, Tournage, Miniature, Découpe).
 */

import { useState } from "react";

import { timelineVide } from "../api/atelier";
import { ETAPES } from "../game/format";
import type { ProprietesMiniJeu } from "./core/types";

export function CurseurStub({ stage, onFini }: ProprietesMiniJeu) {
  const [score, setScore] = useState(60);
  const etape = ETAPES[stage];

  return (
    <div className="jeu jeu-stub">
      <p className="etiquette etiquette-bac">stub M2 — pas encore un vrai mini-jeu</p>
      <h3 className="jeu-titre">
        {etape.icone} {etape.nom}
      </h3>
      {/* ⟦C57 · lot 8 · A-174⟧ Une phrase : « Le vrai jeu (« verbe ») arrive : en attendant, c'est toi qui
          décides à quel point cette étape est réussie » est derrière le titre de l'étape (`title`). */}
      <p
        className="jeu-regle"
        title={`Le vrai jeu (« ${etape.verbe} ») arrive : en attendant, c'est toi qui décides à quel point cette étape est réussie.`}
      >
        Règle ton score à la main.
      </p>

      <div className="curseur-stub">
        <input
          type="range"
          min={0}
          max={100}
          step={1}
          value={score}
          onChange={(e) => setScore(Number(e.target.value))}
          aria-label={`Score de l'étape ${etape.nom}`}
        />
        <output className={`curseur-valeur ${score >= 90 ? "haut" : score < 30 ? "bas" : ""}`}>
          {score}
        </output>
      </div>

      <p className="jeu-seuils" title="≥ 90 : bonus de viralité · < 30 : risque de vidéo nulle">
        ≥ 90 : bonus · &lt; 30 : risque
      </p>

      {/* Aucun geste n'a été joué : la timeline soumise est **vide**, et le serveur la notera
          comme telle. Un stub ne peut pas produire une vidéo en mode compte — c'est la bonne
          réponse, pas une limite à contourner. */}
      <button
        className="bouton primaire"
        type="button"
        onClick={() => onFini(score, timelineVide(stage))}
      >
        Valider {score}
      </button>
    </div>
  );
}
